import { BoltFillColorVioletIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { isPlanGatedQuizType } from '@/shared/plan/consts';
import { type QuizType } from '../../type';
import { QUIZ_TYPE_ICON_MAP } from './QuizTypeIcons';
import { QUIZ_TYPE_LABEL_KEY } from './QuizTypeLabels';
export const QuizTypeSelectorOption = ({
  type
}: {
  type: QuizType;
}) => {
  const {
    t
  } = useTranslation(['build', 'common']);
  const shouldShowProIcon = isPlanGatedQuizType(type);
  return <span className="flex items-center gap-3xs" data-sentry-component="QuizTypeSelectorOption" data-sentry-source-file="QuizTypeSelectorOption.tsx">
      {QUIZ_TYPE_ICON_MAP[type]}
      <span className="text-body-md-medium">
        {t(QUIZ_TYPE_LABEL_KEY[type])}
      </span>
      {shouldShowProIcon && <BoltFillColorVioletIcon data-testid="match-plan-glyph" width={14} height={14} aria-hidden={true} />}
    </span>;
};